import type { InjectionKey } from 'vue';
import {
    ProductApi,
    SupplierApi,
    TemplateApi,
} from '@precon-tools-suite-by-shared/gino-importer-client';

export const importApiBaseUrlInjectionKey = Symbol(
    'gino-imports-api-base-url'
) as InjectionKey<string>;

export const ginoImportProductsClientInjectionKey = Symbol(
    'gino-imports product-api client'
) as InjectionKey<Readonly<ProductApi>>;

export const ginoImportSuppliersClientInjectionKey = Symbol(
    'gino-imports supplier-api client'
) as InjectionKey<Readonly<SupplierApi>>;

export const ginoImportTemplateClientInjectionKey = Symbol(
    'gino-imports template-api client'
) as InjectionKey<Readonly<TemplateApi>>;
